import dynamic from 'next/dynamic'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useCmsBlock } from '@bluheadless/ui-logic/src/hooks/cms/useCmsBlock'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/system'
import { oneOf } from 'prop-types'
import Block from '../../particles/cms-block/block'

const FooterBar = dynamic(() => import('./footer-bar/footer-bar'))
const FooterFourRowsAlternative = dynamic(() => import('./four-rows-alternative/footer'))
const FooterFourRows = dynamic(() => import('./four-rows/footer'))
const FooterRestricted = dynamic(() => import('./restricted/footer'))
const FooterThreeRows = dynamic(() => import('./three-rows/footer'))

const Footer = ({ menus, variant, ...props }) => {
	const {
		footerBar: { enabled, cmsBlockIdentifier },
	} = useConfig()
	const { content } = useCmsBlock({ identifier: enabled ? cmsBlockIdentifier : null })
	let footerVariant

	const theme = useTheme()
	const mdUp = useMediaQuery(theme.breakpoints.up('md'))
	let menusComputed = []

	switch (variant) {
		case 'three-rows':
			footerVariant = <FooterThreeRows menus={menus} {...props} />

			break
		case 'four-rows':
			footerVariant = <FooterFourRows menus={menus} {...props} />

			break
		case 'four-rows-alternative':
			if (mdUp) {
				menusComputed = menus
			} else {
				menus.forEach((item) => {
					if (item.cssClasses?.includes('waterfall')) {
						item.children?.forEach((child) => {
							menusComputed.push(child)
						})
					} else {
						menusComputed.push(item)
					}
				})
			}

			footerVariant = <FooterFourRowsAlternative menus={menusComputed} {...props} />

			break

		case 'restricted':
			footerVariant = <FooterRestricted {...props} />

			break
		default:
			footerVariant = null
	}

	return (
		<>
			{footerVariant}
			{enabled && content ? (
				<FooterBar
					iconProps={{ fontSize: 'medium' }}
					textProps={{
						variant: 'body2',
					}}
				>
					<Block content={content} />
				</FooterBar>
			) : null}
		</>
	)
}

Footer.defaultProps = { variant: 'three-rows' }

Footer.propTypes = { variant: oneOf(['three-rows', 'four-rows', 'four-rows-alternative', 'restricted']) }

export default Footer
